import { render, staticRenderFns } from "./UserGroupSelector.vue?vue&type=template&id=85394c9e"
import script from "./UserGroupSelector.vue?vue&type=script&lang=ts"
export * from "./UserGroupSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports